module.exports = __webpack_public_path__ + "img/reject.56d25844.png";